/**
 * Vendor Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VendorBankAccountDTO } from './vendorBankAccountDTO';


export interface VendorDetailsVO { 
    id?: number;
    vendorCode?: string;
    vendorName?: string;
    vendorEmail?: string;
    vendorPhone?: string;
    vendorAddress?: string;
    description?: string;
    country?: string;
    taxNumber?: string;
    vendorType?: string;
    billingCurrency?: string;
    paymentTerm?: string;
    paymentMethod?: string;
    bankAccountName?: string;
    bankAccountNumber?: string;
    bankName?: string;
    swiftCode?: string;
    category?: string;
    riskLevel?: string;
    status?: VendorDetailsVO.StatusEnum;
    nextPossibleStatuses?: Array<VendorDetailsVO.NextPossibleStatusesEnum>;
    creationDate?: string;
    lastUpdateDate?: string;
    createdBy?: string;
    lastUpdatedBy?: string;
    bankAccounts?: Array<VendorBankAccountDTO>;
    vendorPostingGroup?: string;
    generalBusinessPostingGroup?: string;
    vatBusinessPostingGroup?: string;
    invoiceDiscCode?: string;
}
export namespace VendorDetailsVO {
    export const StatusEnum = {
        Draft: 'DRAFT',
        Reviewing: 'REVIEWING',
        Rejected: 'REJECTED',
        Pending: 'PENDING',
        Approved: 'APPROVED',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const NextPossibleStatusesEnum = {
        Draft: 'DRAFT',
        Reviewing: 'REVIEWING',
        Rejected: 'REJECTED',
        Pending: 'PENDING',
        Approved: 'APPROVED',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE'
    } as const;
    export type NextPossibleStatusesEnum = typeof NextPossibleStatusesEnum[keyof typeof NextPossibleStatusesEnum];
}


